export const billingStates = [
  { key: 'NSW', label: 'NSW' },
  { key: 'VIC', label: 'VIC' },
  { key: 'QLD', label: 'QLD' },
  { key: 'WA', label: 'WA' },
  { key: 'SA', label: 'SA' },
  { key: 'TAS', label: 'TAS' },
  { key: 'NT', label: 'NT' },
  { key: 'ACT', label: 'ACT' },
];